import React, { Fragment } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import CollectionTitle from "../../../atoms/CollectionTitle";
import StoryCard from "../StoryCard";

import "./first-collection.m.css";

const FirstStory = ({ story, associatedMetadata, isHeroStory, sectionSlug }) => {
  const showTimeStamp = associatedMetadata.show_timestamp || null;
  const showReadTime = associatedMetadata.show_read_time || null;
  const showSubHeadline = associatedMetadata.show_sub_headline || null;

  return (
    <StoryCard
      story={story}
      showTimeStamp={showTimeStamp}
      showReadTime={showReadTime}
      showSubHeadline={showSubHeadline}
      isHeroStory={isHeroStory}
      sectionSlug={sectionSlug}
    />
  );
};

const OtherStories = ({ otherStories, associatedMetadata, sectionSlug }) => {
  const showColumnSeparator = associatedMetadata.show_column_separator || null;
  const showTimeStamp = associatedMetadata.show_timestamp || null;
  const showReadTime = associatedMetadata.show_read_time || null;
  return (
    <div styleName={`${showColumnSeparator ? "other-stories-with-separator" : "other-stories"}`}>
      {otherStories.map((item, index) => {
        const { story } = item;
        return (
          <Fragment key={index}>
            <StoryCard
              story={story}
              showTimeStamp={showTimeStamp}
              showReadTime={showReadTime}
              sectionSlug={sectionSlug}
            />
            {showColumnSeparator && index !== otherStories.length - 1 && <div styleName="first-coll-divider"></div>}
          </Fragment>
        );
      })}
    </div>
  );
};

const FirstCollection = ({ collectionItem, associatedMetadata, sectionSlug }) => {
  const showRowTitle = associatedMetadata.show_row_title || null;
  const enableSponsorAd = associatedMetadata.enable_sponsor_ad || null;
  const sponsorAdDetails = associatedMetadata.sponsor_ad_details || null;
  const showColumnSeparator = associatedMetadata.show_column_separator || null;
  const { items } = collectionItem;
  const firstStory = get(items, ["0", "story"]);
  const otherStories = items.slice(1, 3);
  return (
    <div styleName="collection-one">
      {showRowTitle && (
        <CollectionTitle
          collection={collectionItem}
          enableSponsorAd={enableSponsorAd}
          sponsorAdDetails={sponsorAdDetails}
          sectionSlug={sectionSlug}
        />
      )}
      <div styleName={`${showColumnSeparator ? "list-with-separator" : "collection-one-stories"}`}>
        <FirstStory
          story={firstStory}
          associatedMetadata={associatedMetadata}
          isHeroStory={true}
          sectionSlug={sectionSlug}
        />
        {showColumnSeparator && <div styleName="divider"></div>}
        <OtherStories otherStories={otherStories} associatedMetadata={associatedMetadata} sectionSlug={sectionSlug} />
      </div>
    </div>
  );
};

FirstStory.propTypes = {
  story: PropTypes.object,
  associatedMetadata: PropTypes.object,
  isHeroStory: PropTypes.bool,
};

OtherStories.propTypes = {
  otherStories: PropTypes.array,
  associatedMetadata: PropTypes.object,
};

FirstCollection.propTypes = {
  collectionItem: PropTypes.object,
  associatedMetadata: PropTypes.object,
};

FirstCollection.storyLimit = 3;

export default FirstCollection;
